import { render } from "./EFTTermsView.vue?vue&type=template&id=f83f4e1c&scoped=true&ts=true"
import script from "./EFTTermsView.vue?vue&type=script&lang=ts"
export * from "./EFTTermsView.vue?vue&type=script&lang=ts"

import "./EFTTermsView.vue?vue&type=style&index=0&id=f83f4e1c&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83f4e1c"]])

export default __exports__